import React from 'react'
import { Card, Input, Space, Button, Select, Spin } from 'antd'
import { SearchOutlined, PlusOutlined } from '@ant-design/icons'
import { usePromotions } from '../hooks/usePromotions'
import { usePromotionActions } from '../hooks/usePromotionActions'
import { PromotionsTable } from '../components/PromotionsTable'
import { PromotionFormModal } from '../components/PromotionFormModal'

const { Option } = Select

export const PromotionsScreen: React.FC = () => {
    const {
        promotions,
        searchText, setSearchText,
        statusFilter, setStatusFilter,
        isLoading,
        isFetching
    } = usePromotions()

    const {
        isFormModalOpen,
        editingPromotion,
        handleAddPromotion,
        handleEditPromotion,
        handleDeletePromotion,
        handleFormSubmit,
        closeFormModal,
        isSubmitting,
    } = usePromotionActions()

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search promotions..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Select
                        placeholder="Filter by status"
                        style={{ width: 150 }}
                        value={statusFilter}
                        onChange={setStatusFilter}
                    >
                        <Option value="all">All Status</Option>
                        <Option value="active">Active</Option>
                        <Option value="inactive">Inactive</Option>
                    </Select>
                    <Button type="primary" icon={<PlusOutlined />} onClick={handleAddPromotion}>
                        Add Promotion
                    </Button>
                </Space>

                <Spin spinning={isLoading || isFetching}>
                    <PromotionsTable
                        promotions={promotions}
                        onEdit={handleEditPromotion}
                        onDelete={handleDeletePromotion}
                    />
                </Spin>
            </Card>

            <PromotionFormModal
                open={isFormModalOpen}
                onCancel={closeFormModal}
                onSubmit={handleFormSubmit}
                initialValues={editingPromotion}
                isSubmitting={isSubmitting}
            />
        </Space>
    )
}
